var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oz-toggle',{attrs:{"initialValue":_vm.initialValue,"is-pill":_vm.isPill,"title":"Endereço completo","data-cy":"full-address"},on:{"filters:update":_vm.updateDisplayAddressType}})
}
var staticRenderFns = []

export { render, staticRenderFns }